<template>
  <div>
    <label v-if="label" class="tw-mb-1 tw-block tw-text-xs dark:tw-text-white">
      {{ label }}
    </label>
    <div
      :class="{
        'tw-block tw-w-full tw-rounded-md tw-border tw-bg-white dark:tw-bg-black dark:tw-text-white': true,
        'focus-within:tw-ring-deep-orange-500 hover:tw-border-deep-orange-500 focus:tw-border-deep-orange-500':
          !disabled,
        'tw-cursor-not-allowed tw-border-gray-300 tw-bg-gray-100 tw-text-gray-500 dark:tw-border-gray-700 dark:tw-bg-gray-800 dark:tw-text-gray-400':
          disabled,
        'tw-border-red-300 dark:tw-border-red-700': error
      }"
    >
      <input
        type="date"
        :value="modelValue"
        :min="minDate"
        :max="maxDate"
        class="tw-block tw-w-full tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-bg-white tw-p-2 placeholder:tw-text-slate-400 hover:tw-border-deep-orange-600 focus:tw-border-deep-orange-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-deep-orange-500 dark:tw-bg-black sm:tw-text-sm"
        :disabled="disabled"
        :title="disabledReason"
        data-testid="studio-date-input"
        @input="onInput"
      />
    </div>
    <div v-if="error" class="tw-mt-1 tw-text-2xs tw-text-red-700">
      {{ error }}
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioDateInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    minDate: {
      type: String,
      default: ''
    },
    maxDate: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledReason: {
      type: String,
      default: ''
    },
    skipValidationBasedOnInitialValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    error(): string {
      if (this.skipValidationBasedOnInitialValue) {
        return '';
      }

      if (!this.modelValue) {
        return 'Please enter a valid date';
      }
      if (this.modelValue && this.maxDate && this.modelValue > this.maxDate) {
        return `Value must be ${moment(this.maxDate).format('DD/MM/YYYY')} or earlier`;
      }
      if (this.modelValue && this.modelValue < this.minDate) {
        return `Value must be ${moment(this.minDate).format('DD/MM/YYYY')} or later`;
      }
      return '';
    }
  },
  methods: {
    onInput(event: Event) {
      this.$emit('update:modelValue', (event.target as HTMLInputElement).value);
    },
    /** @public */
    hasError(): boolean {
      return !!this.error;
    }
  }
});
</script>
